// Backendpoints
export const GETALLCHARACTERS = '/api/characters';
